import { adminHttpClient } from '../../commons/adminHttpClient'
import { NamedItem } from '../../../domain/common/namedItem'

export interface ProspectForSave {
  id: string
  companyName: string
  firstName: string
  lastName: string
  email: string
  secondaryEmails: string[]
  expirationDate: ExpirationDate
  availableExpirationDates: NamedItem[]
  jobTitle: string
  isAle: boolean
}

export enum ExpirationDate {
  None = 0,
  ThirtyDays = 1,
  SixtyDays = 2,
  NinetyDays = 2,
}

const getProspectForSave = (id: string): Promise<ProspectForSave> => {
  return adminHttpClient.get(`/IchraDecisionTool/Prospects/ForSave?prospectId=${id}`)
}

export default getProspectForSave
